<template>


    <div id="page-navigate" class="navigate-wrapper"
        :class="[$t('PageNavigate.classLang'), $t('common.fontFamily'), { 'blank': blankType }]"
        @mouseleave="pageNavigateMouseLeave">
        <div class="mobileLangList langList mobile">
            <a v-if="hasLan('en')" :class="{ 'current-lang': language == 'en' }" 
                href="https://www.ebc.com/" target="_blank" class="lang body-14_regular">English</a>
               <a v-if="hasLan('th')" :class="{ 'current-lang': language == 'th' }" 
                href="https://www.ebc.com/th/" target="_blank" class="lang body-14_regular">ภาษาไทย</a>
                 <a href="https://www.ebc.com/es/" target="_blank" class="lang body-14_regular">Español</a>
             <a href="https://www.ebc.com/pt/" target="_blank" class="lang body-14_regular">Português</a>
              <a v-if="hasLan('ko')" :class="{ 'current-lang': language == 'ko' }" 
                href="https://www.ebc.com/kr/" target="_blank" class="lang body-14_regular">한국어</a>
            <a v-if="hasLan('zh')" :class="{ 'current-lang': language == 'zh' }" 
               @click="changeLange('zh')" href="javascript:;" class="lang body-14_regular">简体中文</a>
            <a v-if="hasLan('ct')" :class="{ 'current-lang': language == 'ct' }" 
                href="https://www.ebc.com/zh/" target="_blank" class="lang body-14_regular">繁體中文</a>
            <a v-if="hasLan('ja')" :class="{ 'current-lang': language == 'ja' }" 
                href="https://www.ebc.com/jp/" target="_blank" class="lang body-14_regular">日本語</a>
                <a v-if="hasLan('vn')" :class="{ 'current-lang': language == 'vn' }" 
                href="https://www.ebc.site/vi/" target="_blank" class="lang body-14_regular">Tiếng Việt</a>
             <a href="https://www.ebc.site/id/" target="_blank" class="lang body-14_regular">Bahasa Indonesia</a>
            <a href="https://www.ebc.com/mn/" target="_blank" class="lang body-14_regular">Монгол</a>
            <a href="https://www.ebc.com/ug/" target="_blank" class="lang body-14_regular">ئۇيغۇر تىلى</a>
            <a href="https://www.ebc.com/ar/" target="_blank" class="lang body-14_regular">العربية</a>
            <a href="https://www.ebc.com/ru/" target="_blank" class="lang body-14_regular">Русский</a>
            <a href="https://www.ebc.com/hi/" target="_blank" class="lang body-14_regular">हिन्दी</a>
            
        </div>
        <div class="navigate-box  box-border flex justify-between items-center">
            <div class="navigate-logo">
                <a href="/">
                    <!-- <img v-if="blankType" class="navigate-logo-img" src="../../assets/image/navigate/logo_light.svg"
                            alt="" /> -->
                    <template v-if="language == 'en'">
                        <img class="navigate-logo-img" src="../../assets/image/navigate/ebcEn.svg" alt="" />
                        <img class="navigate-logo-img navigate-logo-img-w" src="../../assets/image/navigate/ebcEnW.svg"
                            alt="" />
                    </template>
                    <template v-else-if="language == 'zh'">
                        <img class="navigate-logo-img" src="../../assets/image/navigate/ebcZh.svg" alt="" />
                        <img class="navigate-logo-img navigate-logo-img-w" src="../../assets/image/navigate/ebcZhW.svg"
                            alt="" />
                    </template>
                    <template v-else-if="language == 'ct'">
                        <img class="navigate-logo-img" src="../../assets/image/navigate/ebcZh-tw.svg" alt="" />
                        <img class="navigate-logo-img navigate-logo-img-w"
                            src="../../assets/image/navigate/ebcZh-twW.svg" alt="" />
                    </template>
                    <template v-else-if="language == 'ko'">
                        <img class="navigate-logo-img" src="../../assets/image/navigate/ebcKr.png" alt="" />
                        <img class="navigate-logo-img navigate-logo-img-w" src="../../assets/image/navigate/ebcKrW.svg"
                            alt="" />
                    </template>
                    <template v-else-if="language == 'ja'">
                        <img class="navigate-logo-img" src="../../assets/image/navigate/ebcJp.svg" alt="" />
                        <img class="navigate-logo-img navigate-logo-img-w" src="../../assets/image/navigate/ebcJpW.svg"
                            alt="" />
                    </template>
                    <template v-else-if="language == 'th'">
                        <img class="navigate-logo-img" src="../../assets/image/navigate/ebcTh.svg" alt="" />
                        <img class="navigate-logo-img navigate-logo-img-w" src="../../assets/image/navigate/ebcThW.svg"
                            alt="" />
                    </template>
                    <template v-else-if="language == 'vn'">
                        <img class="navigate-logo-img" src="../../assets/image/navigate/ebcVn.svg" alt="" />
                        <img class="navigate-logo-img navigate-logo-img-w" src="../../assets/image/navigate/ebcVnW.svg"
                            alt="" />
                    </template>
                </a>
                <div class="language showLanguage mobile" id="langSelectorM" @click="dealOpenList()">
                    <div class="flex items-center langWord">
                        <span class="md-footnote-regular_12 ">简体中文</span>
                    </div>
                </div>
                <a id="menu" href="javascript:;" @click="dealOpenList('menu')"><span
                        class="iconfont icon-navigate-menu mobile"></span></a>
            </div>
            <div id="linkBox" class="navigate-links navigate-link-box-close">
                <div id="linkList" class="navigate-menu-list">
                    <div class="navigate-menu-item" v-for="(nav, index) in $t('PageNavigate.headlist')" :key="index">
                        <div class="navigate-menu-item-top" @mouseenter.stop="navigateMenuItemTopListEnter">
                            <a class="navigate-menu-item-top-link body-14_medium" 
                                :href="nav.url ? nav.url : 'javascript:;'" @click="navigateMenuItemTopEnter">{{
                                    nav.text }}
                                <span class="iconfont icon-a-down" v-if="nav.menu"></span></a>
                        </div>
                        <div class="navigate-menu-item-content" v-if="nav.menu && nav.menu.length">
                            <div class="navigate-menu-item-content-box">
                                <div class="navigate-menu-item-content-value" v-for="(list, i) in nav.menu">
                                    <div class="navigate-menu-item-content-value-label" v-if="list.tit">
                                        {{ list.tit }}
                                    </div>
                                    <template v-if="list.tit">
                                        <a class="body-16_regular" :href="link.url" v-for="(link, key) in list.list" v-if="!(!ifPc && link.text == '帮助中心') " :target="link.blankTarget?'_blank':''"> {{
                                            link.text }} 
                                <svg v-if="link.text == '美国股票' || link.text == 'ETF'" style="display:inline-block; transform: translateY(-1.3px);" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13.1047 9.45026C11.3673 5.64572 12.4881 4.42487 12.4994 4.41256C12.519 4.39286 12.5216 4.36162 12.5066 4.33687C12.4906 4.31354 12.4611 4.30489 12.4346 4.31576C12.4095 4.32524 9.99138 5.34385 10.2957 7.60173C9.63182 6.99964 6.53377 3.90628 8.42908 0.270506C8.44074 0.247225 8.43712 0.219564 8.4196 0.201384C8.40283 0.182501 8.37555 0.176713 8.35339 0.186163C8.31231 0.202871 7.34554 0.621084 6.57547 1.6768C5.86476 2.64829 5.2034 4.36733 6.09372 7.02783C6.41769 8.28011 5.80688 9.29439 5.47972 9.72491C5.56008 9.42823 5.66149 8.92509 5.64471 8.34765C5.61854 7.50264 5.31671 6.33494 4.02821 5.58015C4.00856 5.56858 3.9828 5.56917 3.96349 5.58305C3.94395 5.5991 3.93515 5.62228 3.94094 5.64635C3.94535 5.66888 4.42741 7.89185 3.58179 8.92003C2.85169 9.80783 2.13687 11.3522 2.52374 12.7826C2.84842 13.9788 3.8617 14.8927 5.53634 15.4963C5.96614 15.6294 6.37662 15.7313 6.831 15.817C6.86007 15.8236 6.88952 15.8055 6.89825 15.777C6.90698 15.7465 6.89316 15.7152 6.86589 15.7022C6.00565 15.3255 5.11854 14.5401 5.77773 12.9455C6.40561 11.5704 6.29325 10.8622 6.16708 10.5583C6.49174 10.7429 7.13633 11.2229 6.97525 12.0656C6.97124 12.0897 6.98176 12.1158 7.00355 12.1281C7.02538 12.142 7.05194 12.1405 7.07154 12.1237C7.09197 12.1078 9.02986 10.4966 8.1489 8.52222C8.58293 8.7753 9.73372 9.65952 9.05528 11.6911C8.82905 12.5637 9.44457 13.192 9.47034 13.2189C9.49078 13.2385 9.52167 13.2422 9.5453 13.2262C9.56817 13.2116 9.57763 13.1811 9.56786 13.1542C9.54791 13.0996 9.08865 11.8496 10.0849 11.1589C10.0318 11.4803 9.94853 12.2736 10.3052 12.7063C10.6247 13.0968 10.9346 13.7352 10.84 14.3592C10.7735 14.7976 10.5172 15.1685 10.0744 15.4579C10.0489 15.4761 10.0398 15.5074 10.0529 15.535C10.0653 15.5626 10.0969 15.575 10.1252 15.5662C11.2188 15.2004 12.6528 14.474 13.2774 13.0888C13.7395 12.0687 13.6814 10.8449 13.1047 9.45026Z" fill="#A52933"></path></svg>
                                            
                                        </a>
                                    </template>
                                    <template v-else>
                                        <div class="navigate-menu-item-content-value" v-for="(link, key) in list.list">
                                            <a class="body-16_regular" :href="link.url">{{ link.text }}</a>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="navigate-menu-item mobile">
                        <div class="navigate-menu-item-top">
                            <a class="navigate-menu-item-top-link body-14_medium word39" target="_blank" href="https://support.ebchelp.com/hc/zh-cn"
                            >帮助中心</a
                            >
                        </div>
        </div>
        <div class="navigate-menu-item mobile">
                        <div class="navigate-menu-item-top">
                            <a class="navigate-menu-item-top-link body-14_medium word39" href="/official-verification"
                            >官方验证</a
                            >
                        </div>
        </div>
                </div>
                <div class="navigate-entry">
                    <div class="navigate-entry-link flex items-center" @mouseenter.stop="navigateEntryLinkEnter">
                        <a :href="FCAUrl" class="body-14_medium word40 secondary-default_medium">
                            {{ $t('PageNavigate.FCA开户') }}
                            
                        </a>
                        <a :href="signupUrl" class="primary-default_medium box-border word41" target="_blank">{{
                            $t('PageNavigate.立即开户')
                        }}
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_27318_6070)">
                                    <path
                                        d="M11.8333 9.66666C11.8333 9.94281 11.6094 10.1667 11.3333 10.1667C11.0571 10.1667 10.8333 9.94281 10.8333 9.66666V5.8737L3.68679 13.0202C3.49153 13.2154 3.17502 13.2154 2.97976 13.0202C2.7845 12.8249 2.7845 12.5084 2.97976 12.3131L10.1262 5.16666H6.33328C6.05713 5.16666 5.83328 4.94281 5.83328 4.66666C5.83328 4.39052 6.05713 4.16666 6.33328 4.16666H11.3333C11.6094 4.16666 11.8333 4.39052 11.8333 4.66666V9.66666Z"
                                        fill="#A52933" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_27318_6070">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>    
                    </a>
                        <a :href="loginUrl" class="nav-link body-14_medium box-border" target="_blank">{{
                            $t('PageNavigate.登录') }}</a>
                    </div>
                    <div id="langSelector" class=" language cursor-pointer flex flex-col justify-start pc"
                        @mouseenter.stop="langMounseEnter">
                        <div class="flex items-center">
                            <span class="body-14_regular ">简体中文</span>
                            <span class="iconfont icon-a-down"></span>
                        </div>
                        <div class="langList">
                            <a v-if="hasLan('en')" :class="{ 'current-lang': language == 'en' }"
                                 href="https://www.ebc.com/" target="_blank" class="lang body-14_medium">English</a>
                            <a v-if="hasLan('th')" :class="{ 'current-lang': language == 'th' }"
                                href="https://www.ebc.com/th/" target="_blank" class="lang body-14_medium">ภาษาไทย</a>
                            <a href="https://www.ebc.com/es/" target="_blank" class="lang body-14_medium">Español</a>
                            <a href="https://www.ebc.com/pt/" target="_blank" class="lang body-14_medium">Português</a>
                            <a v-if="hasLan('ko')" :class="{ 'current-lang': language == 'ko' }"
                                 href="https://www.ebc.com/kr/" target="_blank" class="lang body-14_medium">한국어</a>
                            <a v-if="hasLan('zh')" :class="{ 'current-lang': language == 'zh' }"
                                 href="javascript:;" class="lang body-14_medium" @click="changeLange('zh')">简体中文</a>
                            <a v-if="hasLan('ct')" :class="{ 'current-lang': language == 'ct' }"
                                 href="https://www.ebc.com/zh/" target="_blank" class="lang body-14_medium">繁體中文</a>
                            
                            <a v-if="hasLan('ja')" :class="{ 'current-lang': language == 'ja' }"
                                 href="https://www.ebc.com/jp/" target="_blank" class="lang body-14_medium">日本語</a>
                             <a v-if="hasLan('vn')" :class="{ 'current-lang': language == 'vn' }"
                                href="https://www.ebc.site/vi/" target="_blank" class="lang body-14_medium">Tiếng
                                Việt</a>
                            <a href="https://www.ebc.site/id/" target="_blank" class="lang body-14_medium">Bahasa Indonesia</a>
                            <a href="https://www.ebc.com/mn/" target="_blank" class="lang body-14_medium">Монгол</a>
                            <a href="https://www.ebc.com/ug/" target="_blank" class="lang body-14_medium">ئۇيغۇر تىلى</a>
                            <a href="https://www.ebc.com/ar/" target="_blank" class="lang body-14_medium">العربية</a>
                            <a href="https://www.ebc.com/ru/" target="_blank" class="lang body-14_medium">Русский</a>
                            <a href="https://www.ebc.com/hi/" target="_blank" class="lang body-14_medium">हिन्दी</a>
                        </div>

                    </div>
                    <span class="iconfont sm-navigate-menu icon-navigate-menu " @mouseenter="smNavigateMenuMouseEnter"
                        @click="smNavigateMenuClick"></span>
                    <!-- <div class="navigate-help">
                        <div class="navigate-help-item">
                            <a href="/official-verification"><span class="iconfont icon-navigate-channel"></span></a>
                            <div class="navigate-help-item-content">
                                <div class="navigate-help-item-content-arrow"></div>
                                <a href="/official-verification" class="navigate-help-item-content-text">
                                    {{ $t('PageNavigate.官方验证') }}</a>
                            </div>
                        </div>
                        <div class="navigate-help-item">
                            <a :href="$t('PageNavigate.帮助中心Url')" target="_blank"><span
                                    class="iconfont icon-navigate-help"></span></a>
                            <div class="navigate-help-item-content">
                                <div class="navigate-help-item-content-arrow"></div>
                                <a :href="$t('PageNavigate.帮助中心Url')" class="navigate-help-item-content-text"
                                    target="_blank">{{
                                        $t('PageNavigate.帮助中心') }}</a>
                            </div>
                        </div>
                        <div ref="languageBox" class="navigate-menu-item">
                            <div class="navigate-menu-item-top">
                                <a class="navigate-menu-item-top-link" href="javascript:;"><span
                                        class="iconfont icon-navigate-language"></span></a>
                            </div>
                            <div class="navigate-menu-item-content mobile-lang-selector">
                                
                            </div>
                        </div>
                    </div> -->
                </div>
                <!-- <div class="navigate-mask mobile"></div> -->
            </div>
        </div>
    </div>

</template>
<script>
import { mapGetters } from 'vuex';
let pageNavigate, linkList, navigateMenuItemList, header;
export default {
    inject: ['reload'], //注入App里的reload方法
    props: {
        langList: {
            type: Array,
            default: () => {
                return ['zh', 'ct', 'en', 'ja', 'ko', 'th', 'vn',]
            }
        },
        blankType: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            onScroll: '',
            onResizeForGetVh: '',
            isScrollDisabled: false,
            scrollPosition: 0,
            ifPc:false
        }
    },
    computed: {

        ...mapGetters([
            'language',
            'FCAUrl',
            'signupUrl',
            'loginUrl',
        ])
    },
    created() {

    },

    mounted() {
        this.setDom();
        this.initNavigate();
        this.initListener();
        let dealLeftLayout = setInterval(()=>{
            this.setTrueViewportHeight()
        },200)
        this.ifPc = window.matchMedia('(min-width: 996px)').matches
        setTimeout(()=>clearInterval(dealLeftLayout),3000)
    },

    methods: {
        setDom() {
            pageNavigate = document.getElementById("page-navigate");
            linkList = document.getElementById("linkList");
            navigateMenuItemList = linkList.getElementsByClassName("navigate-menu-item");
            header = document.getElementById("page-navigate");
        },
        changeLange(language) {
            this.$store.commit("setLanguage", language);
            this.clearNavigateMenuItemList();
            this.enableScroll();
            // this.$refs.languageBox.classList.remove('navigate-menu-item-content-selected');
            this.reload();
        },
        hasLan(language) {
            return this.langList.includes(language)
        },

        throttle(fn, delay = 200) {
            let timer = null;
            return function (...args) {
                if (timer) return;
                timer = setTimeout(() => {
                    fn.apply(this, args);
                    timer = null;
                }, delay);
            };
        },
        toggleHeaderBg() {
            // 居于页面顶部时，导航栏透明
            if (window.scrollY === 0 && !document.querySelector(".whiteBg")) {
                header.classList.add("transparent");
            } else {
                header.classList.remove("transparent");
            }
        },
        setTrueViewportHeight() {
            const vh = document.documentElement.clientHeight * 0.01; // 获取当前视口高度的1%
            document.documentElement.style.setProperty("--vh", `${vh}px`); // 设置为CSS自定义属性
            if (window.matchMedia('(max-width: 1320px)').matches) return
            setTimeout(() => {
                const targetLeft = linkBox.getBoundingClientRect().left;
                document.documentElement.style.setProperty('--navigate-contentbox-left', targetLeft + 'px');
            })

        },
        langMounseEnter(e) {
            if (window.matchMedia("(max-width: 996px)").matches || document.querySelector('.sm-navigate-menu.icon-close')) return;
            e.target.classList.add("active");
            document
                .querySelector(".navigate-menu-item-content-selected")
                ?.classList.remove("navigate-menu-item-content-selected");
            // navigateHoverBg.classList.add("showNavigateHoverBg");
            pageNavigate.classList.add("whiteBg");
            if (!window.scrollY) {
                document.getElementById("page-navigate").classList.remove("transparent");
            }
        },
        initListener() {
            this.toggleHeaderBg();
            this.onScroll = this.throttle(this.toggleHeaderBg, 200);
            window.addEventListener("scroll", this.onScroll, { passive: true });
            this.setTrueViewportHeight();
            // 监听窗口大小变化事件（包括地址栏的显示隐藏）
            this.onResizeForGetVh = this.throttle(this.setTrueViewportHeight, 200);
            window.addEventListener("resize", this.onResizeForGetVh);
            window.addEventListener("orientationchange", this.setTrueViewportHeight); // 监听横竖屏切换

        },
        cancelListenr() {
            window.removeEventListener("scroll", this.onScroll, { passive: true });
            window.removeEventListener("resize", this.onResizeForGetVh);
            window.removeEventListener("orientationchange", this.setTrueViewportHeight); // 监听横竖屏切换
        },
        navigateMenuItemTopEnter(e) {
            if (!window.matchMedia("(max-width: 1320px)").matches) return;
            if (e.target.nodeName === "SPAN") {
                e.target.parentNode.parentNode.parentNode.classList.toggle(
                    "navigate-menu-item-content-selected"
                );
            } else {
                e.target.parentNode.parentNode.classList.toggle(
                    "navigate-menu-item-content-selected"
                );
            }
        },
        navigateEntryLinkEnter() {
            if (window.matchMedia("(max-width: 996px)").matches || document.querySelector('.sm-navigate-menu.icon-close')) return;
            this.clearNavigateMenuItemList();
        },
        navigateMenuItemTopListEnter(e) {
            console.log(e)
            if (window.matchMedia("(max-width: 1320px)").matches || document.querySelector('.sm-navigate-menu.icon-close')) return;

            for (let j = 0; j < navigateMenuItemList.length; j++) {
                if (e.target.parentNode == navigateMenuItemList[j]) {
                    e.target.parentNode.classList.add(
                        "navigate-menu-item-content-selected"
                    );
                    langSelector.classList.remove("active");
                    if( e.target.parentElement.querySelector('.navigate-menu-item-content')){
          navigateHoverBg.classList.add("showNavigateHoverBg");
        } else {
          navigateHoverBg.classList.remove("showNavigateHoverBg");

        } 
                    pageNavigate.classList.add("whiteBg");
                    if (!window.scrollY) {
                        pageNavigate.classList.remove("transparent");
                    }
                } else {
                    navigateMenuItemList[j].classList.remove(
                        "navigate-menu-item-content-selected"
                    );
                }
            }
        },
        pageNavigateMouseLeave() {
            if (window.matchMedia("(max-width: 1320px)").matches) {
                if (document.querySelector('.sm-navigate-menu')) {
                    // 小屏移除语言展开
                    langSelector.classList.remove("active");
                    navigateHoverBg.classList.remove("showNavigateHoverBg");
                }
                if (document.querySelector('.sm-navigate-menu.icon-close') || window.matchMedia("(max-width: 996px)").matches) return
                document.getElementById("page-navigate").classList.remove("whiteBg");
                if (!window.scrollY) {
                    console.log("transparentadd2");
                    document.getElementById("page-navigate").classList.add("transparent");
                }
                return
            };
            this.clearNavigateMenuItemList();
            navigateHoverBg.classList.remove("showNavigateHoverBg");
        },
        // 清除选中展开样式
        clearNavigateMenuItemList() {
            if (window.matchMedia("(max-width: 996px)").matches) return;
            for (let i = 0; i < navigateMenuItemList.length; i++) {
                navigateMenuItemList[i].classList.remove(
                    "navigate-menu-item-content-selected"
                );
            }
            langSelector.classList.remove("active");
            navigateHoverBg.classList.remove("showNavigateHoverBg");
            document.getElementById("page-navigate").classList.remove("whiteBg");
            if (!window.scrollY) {
                console.log("transparentadd1");
                document.getElementById("page-navigate").classList.add("transparent");
            }
        },
        smNavigateMenuMouseEnter() {
            if (document.querySelector('.sm-navigate-menu.icon-close')) return
            this.clearNavigateMenuItemList();
        },
        smNavigateMenuClick() {
            let pageNavigate = document.getElementById("page-navigate");
            if (document.querySelector('.sm-navigate-menu.icon-navigate-menu')) {
                linkBox.classList.remove("navigate-link-box-close");
                pageNavigate.classList.add("whiteBg");
                pageNavigate.classList.remove("transparent");
                // document.documentElement.style.overflow = "hidden";
            } else {
                linkBox.classList.add("navigate-link-box-close");

                // document.documentElement.style.overflow = "auto";
                pageNavigate.classList.remove("whiteBg");
                if (!window.scrollY) {
                    pageNavigate.classList.add("transparent");

                }
            }
            let smNavigateMenu = document.querySelector('.sm-navigate-menu')
            smNavigateMenu.classList.toggle("icon-navigate-menu"); // 打开按钮
            smNavigateMenu.classList.toggle("icon-close"); //关闭按钮
        },
        enableScroll() {
            if (!this.isScrollDisabled) return;

            // 移除CSS类
            document.body.classList.remove("scroll-disabled");
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            if (isIOS) {
                // 恢复页面位置和样式
                document.body.style.position = "";
                document.body.style.top = "";
                document.body.style.width = "";

                // 恢复滚动位置
                window.scrollTo(0, this.scrollPosition);

                // 移除事件监听器
                document.removeEventListener("touchmove", this.preventDefault);
            }

            this.isScrollDisabled = false;
        },

        preventDefault(e) {
            // 检查事件目标是否在允许滚动的元素内
            const allowScrollElements = document.querySelectorAll(
                ".navigate-menu-list,.mobileLangList"
            );
            let isInScrollable = false;

            for (const element of allowScrollElements) {
                if (element.contains(e.target)) {
                    isInScrollable = true;
                    break;
                }
            }

            // 如果不在允许滚动的元素内，阻止默认行为
            if (!isInScrollable) {
                e.preventDefault();
            }
        },
        dealOpenList(from) {
            if (from == "menu" && document.querySelector("#menu .icon-navigate-menu")) {
                // 展开菜单
                linkBox.classList.remove("navigate-link-box-close");
            } else {
                // 关闭菜单
                linkBox.classList.add("navigate-link-box-close");
            }
            let menuIcon = document.querySelector("#menu .iconfont");
            menuIcon.classList.toggle("icon-navigate-menu"); // 打开按钮
            menuIcon.classList.toggle("icon-close"); //关闭按钮
            langSelectorM.classList.toggle("showLanguage"); // menu icon 左侧语言
            if (!from) {
                // 点击展开语言
                document.querySelector(".mobileLangList").classList.add("showLanList");
            } else {
                // 其余操作都是关闭语言
                document.querySelector(".mobileLangList").classList.remove("showLanList");
            }

            if (
                linkBox.classList.contains("navigate-link-box-close") &&
                !document.querySelector(".mobileLangList").classList.contains("showLanList")
            ) {
                // 没有展开语言和菜单
                this.enableScroll();
                console.log("remove1");
                pageNavigate.classList.remove("whiteBg");
                if (!window.scrollY) {
                    console.log("transparentadd4");

                    header.classList.add("transparent");
                }
            } else {
                // 展开语言或菜单 页面顶部白底+禁止滚动
                pageNavigate.classList.add("whiteBg");
                header.classList.remove("transparent");
                this.disableScroll();
            }
        },
        disableScroll() {
            if (this.isScrollDisabled) return;

            // 保存当前滚动位置
            this.scrollPosition = window.pageYOffset;

            // 添加CSS类来禁用滚动
            document.body.classList.add("scroll-disabled");
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            // 对于iOS设备，需要额外处理
            if (isIOS) {
                // 固定页面位置
                document.body.style.position = "fixed";
                document.body.style.top = `-${this.scrollPosition}px`;
                document.body.style.width = "100%";

                // 阻止触摸事件的默认行为
                document.addEventListener("touchmove", this.preventDefault, { passive: false });
            }
            this.isScrollDisabled = true;
        },
        initNavigate() {
            let LangWords = {
                en: "English",
                ja: "Japanese",
                ko: "Korean",
                "zh": "简体中文",
                ct: "繁體中文",
                th: "Thai",
                vn: "Vietnamese",
            };
            document.querySelector("#langSelector span").innerHTML = LangWords["zh"];
            document.querySelector(".navigate-logo .langWord span").innerHTML = LangWords["zh"];

            // 匹配当前路由并高亮
            let hrefReg = new RegExp("^" + window.location.href + "$");
            // console.log("hrefReg", window.location, hrefReg);

            for (let i = 0; i < navigateMenuItemList.length; i++) {
                let linkItems = navigateMenuItemList[i].getElementsByTagName("a");
                for (let j = 0; j < linkItems.length; j++) {
                    // console.log("linkItems[j].href",linkItems[j].href)
                        // console.log(linkItems[j].href,'linkItems')

                    if (linkItems[j].href == location.href) {
                        navigateMenuItemList[i].classList.add("current-group");
                        linkItems[j].classList.add("current-link");
                    }
                }
            }
            // 设置移入动画
            [...document.querySelector(".navigate-entry .langList").children].forEach(
                (child, index) => {
                    child.style.setProperty("--ebc-lang-number", index + 1);
                }
            );

            const listItems = document.querySelectorAll(
                ".navigate-menu-item-content-value"
            );
            listItems.forEach((item, index) => {
                [...item.children].forEach((child, index2) => {
                    child.style.setProperty("--ebc-flyin-number", index2 + 1);
                });
            });
        },

    },
    destroyed() {
        this.cancelListenr()
    }
}
</script>
<style lang="scss" scoped>
@import url("../../assets/css/page-navigate.css");

.blank {
    position: fixed;
    background: rgba(0, 0, 0);
    transition: background 0.3s;
}

.blank:hover {
    background: rgba(0, 0, 0, 1);
}

.blank .navigate-menu-item-content {
    background: rgba(0, 0, 0, 1);
}

@media (max-width: 996px) {
    .navigate-logo-img {
        height: 30px;
    }

    .blank .navigate-menu-list,
    .blank .navigate-entry {
        background: rgba(0, 0, 0, 1);
    }
}

.icon-close:before {
    content: "✖";
    font-size: 16px;
}
</style>